import {
  useDismissParentWhatsAppReminder,
  useGetParentWhatsAppGroups,
  useSetParentWhatsAppGroupJoined,
} from '@actions';
import WhatsAppGroupsModal from './WhatsAppGroupsModal';

interface ParentWhatsAppGroupsModalProps {
  studentId: string;
  token?: string;
}

const ParentWhatsAppGroupsModal = (props: ParentWhatsAppGroupsModalProps) => {
  const { studentId, token } = props;

  const { data, isLoading } = useGetParentWhatsAppGroups(
    { userId: studentId, token: token as string },
    { enabled: !!studentId && !!token }
  );
  const { mutate: setJoined, isLoading: isSaving } = useSetParentWhatsAppGroupJoined();
  const { mutate: dismiss } = useDismissParentWhatsAppReminder();

  const groups = data?.students ?? [];

  return (
    <WhatsAppGroupsModal
      title={groups.length > 1 ? "Join your children's WhatsApp groups" : 'Join the WhatsApp group'}
      description="This is the group where you, your child and their mentor keep in touch. Open it and tick it off once you are in; we will remind you next week otherwise."
      groups={groups}
      dismissedAt={data?.dismissedAt}
      isLoading={isLoading || !data}
      isSaving={isSaving}
      showGroupNames={groups.length > 1}
      onToggleJoined={(childId, joined) =>
        setJoined({ userId: studentId, token: token as string, studentId: childId, joined })
      }
      onDismiss={() => dismiss({ userId: studentId, token: token as string })}
    />
  );
};

export default ParentWhatsAppGroupsModal;
